<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditBlackListEntryDialog(true)"
      >新增黑名单项</el-button
    >

    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      size="mini"
      style="margin-top: 30px"
    >
      <el-form-item label="查询方式：">
        <el-radio-group v-model="form.queryType">
          <el-radio :label="1">按渠道</el-radio>
          <el-radio :label="2">按UID</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="渠道：" v-if="form.queryType == 1">
        <channel-selector
          placeholder="请选择渠道"
          @ready="onChannelSelectorReady"
          @change="onChannelSelectorChange"
          style="display: inline-block"
          ref="channelSelector"
        >
        </channel-selector>
      </el-form-item>
      <el-form-item label="UID：" v-if="form.queryType == 2">
        <el-input v-model="form.uid" clearable style="width: 172px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onClickQueryBtn()"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="blackListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="blackListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 660px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="160">
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="100">
      </el-table-column>
      <el-table-column prop="context" label="备注" align="center" width="250">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteBlackListBtn(scope.row.uid)"
            >删除</el-button
          >
          <el-button
            round
            size="mini"
            @click="onClickViewLogsBtn(scope.row.uid)"
            >日志</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改黑名单项”对话框 -->
    <EditBlackListEntryDialog
      v-if="shouldEditBlackListEntryDialogVisible"
      @close="onEditBlackListEntryDialogClosed()"
      :value="valueForEditBlackListEntryDialog"
    ></EditBlackListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("../../util");

import EditBlackListEntryDialog from "./EditBlackListEntryDialog";
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      shouldEditBlackListEntryDialogVisible: false, // “添加/修改黑名单项”对话框是否应该显示出来
      valueForEditBlackListEntryDialog: null, // 要传递给“添加/修改黑名单项”对话框的数据
      blackListTableData: [], // 黑名单列表里展示的数据
      form: {
        queryType: 1, // 查询方式（1-根据渠道查询 2-根据uid查询）
        uid: "",
        channelId: "",
      },
    };
  },

  created() {},

  components: {
    EditBlackListEntryDialog,
    ChannelSelector,
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    loadMore() {
      this.loadBlackList(this.blackListTableData.length, 20);
    },

    /**
     * 点击了黑名单项的删除按钮
     * @param {*} uid
     */
    onClickDeleteBlackListBtn(uid) {
      this.$confirm("此操作将删除该黑名单项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteBlackListEntry(uid);

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });        
    },

    /**
     * 点击了查看日志按钮
     */
    onClickViewLogsBtn(uid) {
      // 挑战到查询日志页面
      this.$router.push({ path: "/console/misc/clientlog", query: { uid: uid } });
    },

    /**
     * 查询黑名单
     */
    async loadBlackList(skip, limit) {
      switch (this.form.queryType) {
        case 1: {
          // 根据渠道查

          let channelId = parseInt(this.form.channelId);
          if (isNaN(channelId) || channelId <= 0) {
            this.$message({
              message: "请选择渠道",
              type: "error",
            });
            return;
          }

          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.blackListTableData = [];
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/getBlackList`,
              {
                channelId: channelId,
                skip: skip,
                limit: limit,
              },
              {
                headers: {
                  token: util.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.blackLists || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              uid: e.uid,
              context: e.context,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.blackListTableData = this.blackListTableData.concat(list);

          break;
        }
        case 2: {
          // 根据uid查

          let uid = parseInt(this.form.uid);
          if (isNaN(uid) || uid <= 0) {
            this.$message({
              message: "请填入正确的UID",
              type: "error",
            });
            return;
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/getBlackListByUid`,
              {
                uid: uid,
              },
              {
                headers: {
                  token: util.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let blackListInResp = resData.data.blackList;

          let list = [];
          if (blackListInResp) {
            list.push({
              uid: blackListInResp.uid,
              context: blackListInResp.context,
              when: moment(parseInt(blackListInResp.createAt)).format(
                "yyyy-MM-DD HH:mm:ss"
              ),
            });
          }

          this.blackListTableData = list;

          break;
        }
      }
    },

    /**
     * 删除一个黑名单项
     */
    async deleteBlackListEntry(uid) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/deleteBlackList`,
          {
            uidList: [uid],
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 重新拉黑名单
      return this.loadBlackList(0, 20);
    },

    /**
     * 打开“添加/修改黑名单项”对话框
     */
    async openEditBlackListEntryDialog(isCreate, oldData) {
      this.shouldEditBlackListEntryDialogVisible = true;
      this.valueForEditBlackListEntryDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改黑名单项”对话框关闭了
     */
    async onEditBlackListEntryDialogClosed() {
      this.shouldEditBlackListEntryDialogVisible = false;
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadBlackList(0, 20);
    },
  },
};
</script>